import React, { lazy } from 'react';
import { MapPinIcon, ClockIcon, PhoneIcon, ExternalLinkIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Locations() {
  const locationData = [{
    name: 'Annapolis Pharmacy',
    address: '2002 Jennifer Rd, Annapolis, MD 21401',
    phone: '(410) 555-0123',
    googleMapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=2002+Jennifer+Rd+Annapolis+MD+21401',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3091.5645367355!2d-76.5444!3d38.9897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7f6562688997b%3A0x67397730e6686a9d!2s2002%20Jennifer%20Rd%2C%20Annapolis%2C%20MD%2021401!5e0!3m2!1sen!2sus!4v1715980000000!5m2!1sen!2sus',
    hours: [{
      days: 'Mon - Fri',
      time: '9:00 AM - 7:00 PM'
    }, {
      days: 'Sat',
      time: '10:00 AM - 4:00 PM'
    }, {
      days: 'Sun',
      time: 'Closed'
    }]
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white pb-12 sm:pb-24" data-id="element-471" data-mp="2rqzj1nb4wngn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-20 mb-8 sm:mb-16" data-id="element-472" data-mp="31gsijpy05c4j">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4 sm:mb-6 uppercase tracking-tighter" data-id="element-473" data-mp="36g5f52eodxkb">
          Our Locations
        </h1>
        <p className="text-base sm:text-lg text-slate-600 max-w-3xl" data-id="element-474" data-mp="28u7tiw501c45">
          Visit us at either of our convenient locations. We provide
          professional pharmaceutical care and clinical services to our local
          communities.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-475" data-mp="2mso9ldor4eyy">
        <div className="max-w-3xl mx-auto" data-id="element-476" data-mp="2mq366k8t1qz3">
          {locationData.map((loc, idx) => <div key={idx} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-477" data-mp="3u82f9w8rj15l" data-mpi={idx}>
              <div className="aspect-video w-full" data-id="element-478" data-mp="1z104p482dh5r">
                <iframe src={loc.mapUrl} width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={loc.name} className="grayscale hover:grayscale-0 transition-all duration-500" data-id="element-479" data-mp="1u49rconn8zo1"></iframe>
              </div>
              <div className="p-6 sm:p-8" data-id="element-480" data-mp="1p4x1rw5e1ehr">
                <h2 className="text-xl sm:text-2xl font-black text-slate-900 mb-6 uppercase tracking-tight" data-id="element-481" data-mp="1p5yh4ctfsn5a">
                  {loc.name}
                </h2>

                <div className="space-y-6 mb-8" data-id="element-482" data-mp="wnksn3tzqdiv">
                  <div className="flex items-start gap-4" data-id="element-483" data-mp="wlzu734k2afq">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-484" data-mp="rohum3cfh7ke">
                      <MapPinIcon className="w-5 h-5" data-id="element-485" data-mp="33as5qby3x8t0" />
                    </div>
                    <div data-id="element-486" data-mp="385ftu9p78172">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-487" data-mp="2ubwu2kcan6ib">
                        Address
                      </p>
                      <p className="text-slate-600 text-sm leading-relaxed" data-id="element-488" data-mp="2zbjd5aeszgz1">
                        {loc.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-489" data-mp="3r0w3i2om6ec3">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-490" data-mp="3d2xtf9hbt42e">
                      <PhoneIcon className="w-5 h-5" data-id="element-491" data-mp="3hzy2zuddwoy9" />
                    </div>
                    <div data-id="element-492" data-mp="21m7xqkaj3un1">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-493" data-mp="21ly32jejgzb0">
                        Phone
                      </p>
                      <p className="text-slate-600 text-sm" data-id="element-494" data-mp="2lw8yxg6v372u">{loc.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-495" data-mp="2h4habb79nbfc">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-496" data-mp="2d35qxnezjmfl">
                      <ClockIcon className="w-5 h-5" data-id="element-497" data-mp="2865hd2ixg1jq" />
                    </div>
                    <div className="flex-grow" data-id="element-498" data-mp="34ttn0l1sy1me">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-499" data-mp="34sikeok3ezwv">
                        Business Hours
                      </p>
                      <div className="space-y-1" data-id="element-500" data-mp="2vsltshe57qz6">
                        {loc.hours.map((h, i) => <div key={i} className="flex justify-between text-sm text-slate-600" data-id="element-501" data-mp="2quu1vndi04uz" data-mpi={i}>
                            <span data-id="element-502" data-mp="1ff5e4tsf71t4">{h.days}</span>
                            <span className="font-medium" data-id="element-503" data-mp="15c03m4o1b0ij">{h.time}</span>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-504" data-mp="1f9mod7s0lmaf">
                  <a href={loc.googleMapsUrl} target="_blank" rel="noopener noreferrer" className="flex-grow bg-clinical-blue text-white font-bold py-3 sm:py-4 rounded-xl hover:bg-blue-700 transition-colors uppercase tracking-wider text-xs flex items-center justify-center gap-2" data-id="element-505" data-mp="1k0w9bv2mc1fz">
                    Get Directions <ExternalLinkIcon className="w-4 h-4" data-id="element-506" data-mp="22zqmx0qcivuk" />
                  </a>
                  <button className="px-6 border-2 border-clinical-blue text-clinical-blue font-bold py-3 sm:py-4 rounded-xl hover:bg-clinical-blue hover:text-white transition-all uppercase tracking-wider text-xs" data-id="element-507" data-mp="22xnygl4udary">
                    Call Store
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </motion.div>;
}